import { Theme } from '@mui/material/styles'
export const getSelectionPanelStyles = (theme: Theme) => ({
  label: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '14px',
    marginBottom: theme.spacing(1),
  },
})

export const getSearchboxStyles = (theme: Theme) => ({
  textfield: { marginBottom: theme.spacing(2) },
})

export const getSelectButtonsStyles = (theme: Theme) => ({
  button: {
    maxWidth: 'unset',
    marginRight: theme.spacing(0.5),
  },
})

export const selectionListItemStyles = {
  root: { margin: 0 },
  label: { fontSize: '14px' },
}
